module.exports = __webpack_public_path__ + "assets/img/sweep-footer.7740d6cf.webp";